import { useState } from 'react';

import styled from '@mint-lib/styled';

import TableContentContextProvider from '../../context/TableContentContext.jsx';
import useInitiateBuilderQueries from '../../hooks/useInitiateBuilderQueries.js';
import BuilderBody from './BuilderBody/BuilderBody.jsx';
import BuilderHeader from './BuilderHeader/BuilderHeader.jsx';
import EmptyBuilder from './EmptyBuilder.jsx';
import { PanelTab } from './PanelTab.js';

const Builder = () => {
  const [currentTab, setCurrentTab] = useState<PanelTab | null>(null);
  const {
    isBuilderHeaderLoading,
    isBuilderBodyLoading,
    isAvailableMediaPlans,
  } = useInitiateBuilderQueries();

  const handlerTabChange = (tab: PanelTab | null) => setCurrentTab(tab);
  const tabState = { currentTab, setCurrentTab: handlerTabChange };
  const showEmptyBuilder = !isBuilderHeaderLoading && !isAvailableMediaPlans;

  if (showEmptyBuilder) {
    return <EmptyBuilder />;
  }

  return (
    <Wrapper>
      <BuilderHeader tabState={tabState} isLoading={isBuilderHeaderLoading} />
      <TableContentContextProvider>
        <BuilderBody tabState={tabState} isLoading={isBuilderBodyLoading} />
      </TableContentContextProvider>
    </Wrapper>
  );
};

const Wrapper = styled('div')`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-right: ${({ theme }) => theme.spacing(6)};
`;

export default Builder;
